import { percentClient } from '@percent/partner-dashboard/common/HOC/withAxios/WithAxios'
import { logger } from './logger'

export const capabilities = {
  percentClient,
  logger
}
